import React from "react";
import "./HamburgerMenu.css";

class HamburgerMenu extends React.Component {
  render() {
    var buttonClass = "app-menu-button hamburger hamburger--squeeze";
    if (this.props.isMenuOpen) {
      buttonClass = buttonClass + " is-active";
    }
    return (
      <button className={buttonClass} type="button" onClick={this.props.onClick}>
        <span className="hamburger-box">
            <span className="hamburger-inner"></span>
        </span>
      </button>
    )
  }
}

export default HamburgerMenu;



// WEBPACK FOOTER //
// ./src/components/app/bar/HamburgerMenu.js